import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentsComponent } from './journey/departments/departments.component';
import { LoginComponent } from './journey/login/login.component';
import { ServicesComponent } from './journey/services/services.component';
import { LocationComponent } from './journey/location/location.component';
import { CalendarComponent } from './journey/calendar/calendar.component';
import { BookingDetailsComponent } from './journey/booking-details/booking-details.component';
import { SummaryComponent } from './journey/summary/summary.component';
import { ConfirmationComponent } from './journey/confirmation/confirmation.component';
import { RegisterComponent } from './journey/register/register.component';
import { MainAccountComponent } from './account-journey/main-account/main-account.component';
import { GuardService } from './services/guards/guard.service';
import { AccountLoginComponent } from './account-journey/account-login/account-login.component';
import { AccountGuardService } from './services/guards/account-guard.service';
import { ServiceStatusGuardService, ServiceUnavailableComponent } from '@bookinglab/hwrc-ui';
import { DeepLinksComponent } from './journey/deeplink/deeplink.component';
import { PermitsComponent } from './journey/permits/permits.component';
import { PermitsSubmittedComponent } from './journey/permits-submitted/permits-submitted.component';
import { AmendPermitsSubmittedComponent } from './journey/amend-permits-submitted/amend-permits-submitted.component';
import { AmendPermitsComponent } from './journey/amend-permits/amend-permits.component';

const routes: Routes = [
  { path: '', component: DeepLinksComponent },
  { path: 'service-unavailable', component: ServiceUnavailableComponent, data: { recoveryRoute: '/login' } },
  { path: 'departments', component: DepartmentsComponent, canActivate: [ServiceStatusGuardService]},
  { path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' }, canActivate: [ServiceStatusGuardService] },
  {
    path: 'services',
    component: ServicesComponent,
    data: { breadcrumb: 'Services' },
    canActivate: [ServiceStatusGuardService]
  },
  { path: 'locations', component: LocationComponent, canActivate: [ServiceStatusGuardService] },
  { path: 'permits', component: PermitsComponent, canActivate: [ServiceStatusGuardService] },
  { path: 'permits-submitted', component: PermitsSubmittedComponent, canActivate: [ServiceStatusGuardService] },
  { path: 'amend-permits', component: AmendPermitsComponent, canActivate: [ServiceStatusGuardService] },
  { path: 'amend-permits-submitted', component: AmendPermitsSubmittedComponent, canActivate: [ServiceStatusGuardService] },
  {
    path: 'calendar',
    component: CalendarComponent,
    data: { breadcrumb: 'Date & Time' },
    canActivate: [ServiceStatusGuardService]
  },
  {
    path: 'booking-details',
    component: BookingDetailsComponent,
    data: { breadcrumb: 'Booking Form' },
    canActivate: [ServiceStatusGuardService]
  },
  {
    path: 'summary',
    component: SummaryComponent,
    data: { breadcrumb: 'Summary' },
    canActivate: [ServiceStatusGuardService]
  },
  {
    path: 'confirmation',
    component: ConfirmationComponent,
    data: { breadcrumb: 'Confirmation' },
  },
  { path: 'register', component: RegisterComponent, canActivate: [ServiceStatusGuardService] },
  { path: 'account', component: MainAccountComponent, canActivate: [AccountGuardService, ServiceStatusGuardService] },
  // { path: 'account-login', component: AccountLoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
